import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useTranslation } from '../../../common/hooks/useTranslation';
import { usePokCore } from '../../../common/hooks/usePokCore';
import ConfirmationButton from '../../../app/components/ConfirmationButton';
import AlertModal from '../../../app/components/AlertModal';
import { responseErrors } from '../../../common/pokCore/validation/responseErrors';

interface EODJoinDocumentWithFVZLinkProps {
  eodId: number;
  onRefresh: () => void;
}

export const EODJoinDocumentWithFVZLink: React.FC<
  EODJoinDocumentWithFVZLinkProps
> = props => {
  const pok = usePokCore();
  const [isLoading, setIsLoading] = React.useState(false);
  const [showInfo, setShowInfo] = React.useState(false);
  const [info, setInfo] = React.useState('');
  const [success, setSuccess] = React.useState(false);
  const { t, tk } = useTranslation('fvzLng');

  const join = () => {
    setIsLoading(true);
    pok.eodImportLogs
      .joinWithFVZ(props.eodId)
      .then(() => {
        setIsLoading(false);
        setSuccess(true);
        setInfo(t(tk.eod.found));
        setShowInfo(true);
      })
      .catch(async err => {
        const errors = await responseErrors(err);
        setInfo(errors?.[0]);
        setIsLoading(false);
        setSuccess(false);
        setShowInfo(true);
      });
  };

  return (
    <>
      <OverlayTrigger overlay={<Tooltip>{t(tk.common.openNewCard)}</Tooltip>}>
        <ConfirmationButton
          variant="outline-secondary"
          className="px-2"
          onOK={() => join()}
          modalSize="lg"
          confirmation={t(tk.eod.confirmFindFVZ)}
          isLoading={isLoading}
        >
          <Icon.Link size={16} /> {t(tk.eod.findFVZ)}
        </ConfirmationButton>
      </OverlayTrigger>
      <AlertModal
        variant={success ? 'info' : 'danger'}
        buttonText={t(tk.button.close)}
        buttonVariant={'outline-success'}
        size="lg"
        show={showInfo}
        onHide={() => {
          setShowInfo(false);
          props.onRefresh();
        }}
      >
        {info}
      </AlertModal>
    </>
  );
};
